<hw-page-header class="page-header sticky" header="mdm.measurement-unit-02.header">
  <div class="content float-right">
    <button nz-button nzType="primary" (click)="save()" *ngIf="hasEditPrivileges">
      {{ 'core.btn.save' | translate }}
    </button>
    <hw-dropdown>
      <a *hwDropdownItem (click)="exportMeasurementUnit()">
        <i class="dropdown-menu-icon" nz-icon nzType="download" nzTheme="outline"></i>
        {{ 'mdm.measurement-unit-02.export' | translate }}
      </a>
      <a *hwDropdownItem (click)="importMeasurementUnit()">
        <i class="dropdown-menu-icon" nz-icon nzType="upload" nzTheme="outline"></i>
        {{ 'mdm.measurement-unit-02.import' | translate }}
        <input #importMeasurementUnitInp [hidden]="true" type="file" (change)="readFile($event)" />
      </a>
    </hw-dropdown>
  </div>
</hw-page-header>

<nz-content class="page-content">
  <div class="page-content__container container">
    <hw-spinner *ngIf="!unit"></hw-spinner>
    <div nz-col nzSpan="24" *ngIf="unit">
      <hw-form-row [formGroup]="form">
        <div *hw-form-col>
          <hw-form-item name="code" label="mdm.measurement-unit-02.code" required>
            <input nz-input formControlName="code" />
          </hw-form-item>
          <hw-form-item name="names" label="mdm.measurement-unit-02.name" required>
            <hw-multilang-input formControlName="names"></hw-multilang-input>
          </hw-form-item>
          <hw-form-item name="alias" label="mdm.measurement-unit-02.alias" required>
            <hw-multilang-input formControlName="alias"></hw-multilang-input>
          </hw-form-item>
          <div formGroupName="period">
            <hw-form-item name="lower" label="mdm.measurement-unit-02.from" required>
              <hw-date-picker formControlName="lower"></hw-date-picker>
            </hw-form-item>
            <hw-form-item name="upper" label="mdm.measurement-unit-02.to">
              <hw-date-picker formControlName="upper"></hw-date-picker>
            </hw-form-item>
          </div>
          <hw-form-item name="rounding" label="mdm.measurement-unit-02.rounding" required>
            <hw-input-number formControlName="rounding"></hw-input-number>
          </hw-form-item>
          <hw-form-item name="kind" label="mdm.measurement-unit-02.kind" required>
            <hw-term-codesystem-concept-select
              formControlName="kind"
              codesystem="measurement-unit-kind"
              valueType="codeName"></hw-term-codesystem-concept-select>
          </hw-form-item>
          <hw-form-item name="definitionUnit" label="mdm.measurement-unit-02.definition-unit">
            <hw-select formControlName="definitionUnit">
              <hw-option
                *ngFor="let unit of units | filter : sameKind : form.value.kind?.code"
                [label]="unit.names | localName"
                [value]="unit.code"></hw-option>
            </hw-select>
          </hw-form-item>
          <hw-form-item
            name="definitionValue"
            label="mdm.measurement-unit-02.definition-value"
            required
            *ngIf="form.controls.definitionValue">
            <input nz-input formControlName="definitionValue" />
          </hw-form-item>
        </div>
      </hw-form-row>

      <form class="row-table" #mappingsForm="ngForm">
        <hw-flex-editable-table
          #mappingsTable
          header="mdm.measurement-unit-02.mappings.header"
          [form]="mappingsForm"
          [data]="unit.mappings"
          [editMode]="hasEditPrivileges"
          [rowInstance]="defaultMapping">
          <hw-flex-editable-column title="mdm.measurement-unit-02.mappings.system" name="system">
            <ng-template #viewTemplate let-mapping>
              {{ mapping.system | localizedConceptName : 'measurement-unit-mapping-system' | async }}
            </ng-template>
            <ng-template #editTemplate let-mapping>
              <hw-term-codesystem-concept-select
                name="system"
                [(ngModel)]="mapping.system"
                codesystem="measurement-unit-mapping-system"
                required></hw-term-codesystem-concept-select>
            </ng-template>
          </hw-flex-editable-column>
          <hw-flex-editable-column title="mdm.measurement-unit-02.mappings.unit" name="unit">
            <ng-template #viewTemplate let-mapping>
              {{ mapping.systemUnit }}
            </ng-template>
            <ng-template #editTemplate let-mapping>
              <input nz-input name="unit" [(ngModel)]="mapping.systemUnit" required />
            </ng-template>
          </hw-flex-editable-column>
          <hw-flex-editable-column title="mdm.measurement-unit-02.mappings.value" name="value">
            <ng-template #viewTemplate let-mapping>
              {{ mapping.systemValue }}
            </ng-template>
            <ng-template #editTemplate let-mapping>
              <input nz-input name="value" [(ngModel)]="mapping.systemValue" required />
            </ng-template>
          </hw-flex-editable-column>
        </hw-flex-editable-table>
      </form>
    </div>
  </div>
</nz-content>
